import {
  MODELS_HELPER_TEXT,
  MODELS_PREFIX,
  openAiModelsFetch,
  withAllowedModelsHint,
} from "../models";
import { openaiUsage } from "../openai/usage";
import { OPENAI_COMPATIBLE_USAGE_HINT } from "../openai/usageHint";
import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const DEFAULT_TOGETHER_BASE_URL = "https://api.together.ai/v1";

const MODELS_ENDPOINT = `${DEFAULT_TOGETHER_BASE_URL}/models`;

const togetherModelsFetch = openAiModelsFetch(
  "Fetch models from Together AI",
  () => MODELS_ENDPOINT
);

export const togetherAi = defineConnector({
  identifier: "togetherAi",
  name: "Together AI",
  tagLine: "Open-model AI inference",
  logo,
  protocol: "http",
  tags: ["ai", "engineering"],
  defaultUrlPattern: () => "https://api\\.together\\.(ai|xyz)/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Go to [API keys](https://api.together.ai/settings/projects/~current/api-keys) in your Together AI project settings and create a new key.",
        },
      ],
    },
    {
      title: "Paste your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
    {
      title: "Choose available models (optional)",
      items: [
        {
          kind: "list",
          label: "Available models",
          prefix: MODELS_PREFIX,
          columns: [
            {
              field: "name",
              placeholder: "meta-llama/Llama-3.3-70B-Instruct-Turbo",
            },
          ],
          addLabel: "Add model",
          fetch: togetherModelsFetch,
          helperText: MODELS_HELPER_TEXT,
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => MODELS_ENDPOINT,
  },
  usageHint: (configuration) =>
    withAllowedModelsHint(OPENAI_COMPATIBLE_USAGE_HINT, configuration),
  usage: openaiUsage(),
});
